import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DescargoEstadoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DescargoEstadoPage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexDescargoEstado(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'DescargoEstado', name: 'DescargoEstado', title: 'Tipo de Pago' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción'},
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            descargoestados: [],
            descargoestado: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newDescargoEstado() {
            this.descargoestado = {};
            this.$refs['frm-descargoestado'].show();
        },
        showDescargoEstado(id) {
            this.isLoading=true;
            this.ss.showDescargoEstado(id).then(
                (result) => {
                    let response = result.data;
                    this.descargoestado = response.data;
                    this.$refs['view-descargoestado'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDescargoEstado() {
            this.$refs['frm-descargoestado'].show();
            this.$refs['view-descargoestado'].hide();
        },
        cancelDescargoEstado() {
            if (this.descargoestado.id) {
                this.$refs['view-descargoestado'].show();
            }
            this.$refs['frm-descargoestado'].hide();
        },
        saveDescargoEstado() {
            this.ss.storeDescargoEstado(this.descargoestado).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-descargoestado'].hide();
                    this.$refs['datatable-descargoestado'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDescargoEstado() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyDescargoEstado(this.descargoestado)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-descargoestado'].hide();
                                this.$refs['datatable-descargoestado'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-DescargoEstado').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDescargoEstado(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
